import { render, staticRenderFns } from "./BlogHtmlFile.vue?vue&type=template&id=67136b3a"
import script from "./BlogHtmlFile.vue?vue&type=script&lang=js"
export * from "./BlogHtmlFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports